





import {
  defineComponent,
} from '@vue/composition-api';

import PageColumnWithSupplierEditor from '@/components/Supplier/PageColumnWithSupplierEditor.vue';

const Create = defineComponent({
  // setup() {},
  components: {
    PageColumnWithSupplierEditor,
  },
});

export default Create;
